import React, {Component} from 'react'
import './BenefitsSection.scss'


export default class BenefitsSection extends Component {

    handleItemClick = (e, { name }) => this.setState({ activeItem: name })

    render() {


        return (

            <div id='benefits'>

                <div className='section-wrapper benefits-section'>

                    <div className='section-content benefits-section'>

                        <div className='benefits-header'>
                            Why no.ID <br/> for data protection?
                        </div>

                        <svg id="path" width="100%" height="100%" viewBox="0 0 994 1065">
                            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-dasharray="4" stroke-linejoin="bevel">
                                <g transform="translate(-225.000000, -1710.000000)" stroke="#5EDED2">
                                    <g transform="translate(0.000000, 1553.000000)">
                                        <path d="M929.003906,158 C958.256893,160.248685 957.281814,158.729535 996.03125,176.519531 C1042.30562,197.764249 1050.21844,259.075378 1023.70703,286.382813 C997.115269,313.773008 930.355209,332.549293 894.5,336.683594 C826.1333,344.566647 757.664016,306.278372 689.59375,297.816406 C633.959353,290.900371 573.442126,276.837237 516.566406,286.382813 C450.37441,297.491959 369.73409,354.494384 322.925781,396.25 C269.659977,443.766061 251.403122,482.770558 229.796875,550.816406 C222.176875,574.814529 225.670313,604.529828 242.355469,623.984375 C259.478946,643.949997 288.844119,655.792417 313.191406,663.367188 C366.977931,680.100903 436.952593,697.090533 492.796875,676.6875 C521.52757,666.190574 558.228696,645.115382 582.03125,628.328125 C618.35694,602.708661 647.96781,568.340089 689.257813,549.5 C770.190256,512.571583 896.540185,522.133358 981.863281,534.011719 C1058.48591,544.678833 1124.17256,560.996083 1180.40625,615.925781 C1193.7307,628.941249 1220.18324,654.660867 1217.73828,677.714844 C1214.06745,712.327817 1199.0222,749.843758 1170.75,763.058594 C1132.8263,780.784678 1090.99892,803.209029 1052.5,819.648438 C969.577976,855.056936 861.219384,836.52753 772.648437,834.167969 C763.657601,833.92845 754.700015,832.81726 745.789062,831.597656 C719.328213,827.976072 693.056102,823.022086 666.5625,819.648438 C586.632164,809.47025 493.207288,795.37142 415.246094,827.195313 C406.332959,830.83367 397.665963,835.195151 389.53125,840.34375 C383.197354,844.352581 377.567332,849.419073 372.074219,854.519531 C365.213566,860.889775 358.54507,867.516907 352.535156,874.695313 C347.900877,880.230622 343.81932,886.256209 340.25,892.53125 C336.87681,898.461484 334.157166,904.769674 331.789063,911.167969 C327.723064,922.153745 324.069047,933.306966 320.976563,944.605469 C319.069734,951.572133 317.225323,958.659769 316.816406,965.871094 C315.385798,991.10016 314.172956,1016.43182 315.472656,1041.66797 C316.063148,1053.13349 319.769746,1064.23275 322.457031,1075.39453 C324.919769,1085.62365 327.795749,1095.75601 330.914063,1105.80469 C332.990585,1112.49623 335.220136,1119.16438 338.03125,1125.58203 C340.025897,1130.13572 342.456901,1134.5248 345.285156,1138.61328 C348.190297,1142.81291 351.599736,1146.66383 355.152344,1150.33203 C358.979582,1154.2838 363.099842,1157.95961 367.375,1161.42188 C373.205257,1166.14354 379.159567,1170.74176 385.433594,1174.85547 C391.736205,1178.98792 398.248868,1182.84712 405.039063,1186.11719 C456.610766,1210.95343 522.96294,1199.4884 576.726563,1193.43359 C681.711288,1181.61032 726.768516,1168.86246 811.726563,1106.60547 C816.238099,1103.29943 820.339256,1099.43126 824.214844,1095.39844 C841.501942,1077.40998 847.957195,1043.48759 865.921875,1026.17578 C905.026153,988.492631 877.925061,992.271925 929.003906,982" id="Path-2"></path>
                                    </g>
                                </g>
                            </g>

                            <foreignObject>
                                <div className='benefit-item'>

                                    <div className='image-wrapper'>
                                        <img src='/images/relaxed-man-on-the-cloud.png'/>
                                    </div>

                                    <div className='description'>
                                        <div className='header'>
                                            Full control over <br/>who knows what
                                        </div>
                                        <p>
                                            Businesses see you as different
                                            personas, there is no link between 
                                            them, and none of those personas 
                                            can lead to your real identity.
                                        </p>
                                    </div>

                                </div>
                            </foreignObject>

                            <foreignObject>
                                <div className='benefit-item'>

                                    <div className='image-wrapper'>
                                        <img src='/images/virtual-card.png'/>
                                    </div>

                                    <div className='description'>
                                        <div className='header'>
                                        Secure payments environment
                                        </div>
                                        <p>
                                            You get a unique card number for 
                                            an individual merchant or transaction 
                                            to prevent websites from tracking 
                                            your shopping habits.
                                        </p>
                                    </div>

                                </div>
                            </foreignObject>

                            <foreignObject>
                                <div className='benefit-item'>

                                    <div className='image-wrapper'>
                                        <img src='/images/no-spam-no-robocalling-no-bothering.png'/>
                                    </div>

                                    <div className='description'>
                                        <div className='header'>
                                            No spam, <br/>no robocalling, <br/>no bothering
                                        </div>
                                        <p>
                                            Leverage masked emails 
                                            and phone numbers to communicate 
                                            with online services, make business deals, 
                                            or sell on auction sites.
                                        </p>
                                    </div>

                                </div>
                            </foreignObject>

                            <foreignObject>
                                <div className='benefit-item'>

                                    <div className='image-wrapper'>
                                        <img src='/images/hook-phishing-attact.png'/>
                                    </div>

                                    <div className='description'>
                                        <div className='header'>
                                            Unique identities
                                            for phishing attacks
                                        </div>
                                        <p>
                                            Dedicated identities protect you
                                            against threat actors posing as trusted
                                            persons or organizations to trick you
                                            into sharing your sensitive data.
                                        </p>
                                    </div>

                                </div>
                            </foreignObject>

                        </svg>

                        <svg id="path-tablet" width="100%" height="100%" viewBox="0 0 692 1085">

                            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-dasharray="4" stroke-linejoin="bevel">
                                <g transform="translate(-38.000000, -1537.000000)" stroke="#5EDED2">
                                    <g transform="translate(0.000000, 1413.000000)">
                                        <path d="M484.421841,126 C520.898765,121.143671 634.519211,146.783714 625.146712,206.980469 C621.21215,232.250986 571.664849,254.351387 552.525203,261.855469 C479.827111,290.358214 397.65405,274.467075 322.027372,287.234375 C283.917614,293.668067 256.617826,305.371256 221.273069,324.789063 C151.577416,363.078664 126.464322,387.434044 82.4399573,453.234375 C66.4386218,477.150522 51.0157557,504.869666 44.0985105,533.488281 C42.0652705,541.900375 40.7872305,550.500459 39.7173922,559.097656 C39.3011019,562.442956 38.3164755,566.133749 39.6526841,569.214844 C49.7465829,592.489849 61.8318772,614.809644 73.6053998,637.238281 C81.7086671,652.675058 131.625695,678.000707 148.845684,685.484375 C238.601268,724.491427 338.358288,690.719325 417.026461,643.070313 C453.289127,621.106155 515.883193,565.180041 567.377613,557.097656 C606.78965,550.91168 657.723309,560.766725 690.311566,585.679688 C710.696885,601.263789 732.412523,624.053051 728.51979,652.902344 C720.705783,710.812455 709.654305,776.650331 675.459156,825.132812 C658.521987,849.146627 618.586698,856.643285 591.715468,860.800781 C532.423806,869.974343 470.768161,873.601473 410.943901,868.917969 C386.765276,867.02508 362.796277,862.571736 338.581224,861.257812 C264.098516,857.216336 222.863832,865.756819 169.715946,920.25 C159.505325,930.719075 151.665293,943.422254 141.651666,954.089844 C134.022029,962.217753 124.826581,968.654071 116.91795,976.496094 C97.4691456,995.781098 97.8718935,1032.67261 98.8605869,1056.98047 C99.1145015,1063.22317 101.105453,1069.33609 103.31022,1075.16016 C105.739859,1081.57824 108.873419,1087.76958 112.666248,1093.44922 C117.838182,1101.19403 123.557317,1108.63519 130.068918,1115.23047 C136.366595,1121.60907 143.625815,1126.94082 150.874473,1132.14844 C155.565823,1135.51882 160.66506,1138.27542 165.791591,1140.89453 C174.700869,1145.44622 183.688352,1149.88246 192.942344,1153.64062 C200.465729,1156.69597 208.17183,1159.3624 216.039326,1161.30078 C273.539692,1175.46762 332.787265,1166.73674 385.624006,1140.09375 C404.01207,1130.82155 421.850697,1120.41608 439.533458,1109.79688 C444.6939,1106.69782 450.268609,1103.74195 454.058521,1098.99609 C456.481798,1095.96158 456.152018,1091.44922 457.198767,1087.67578" id="Path-4"></path>
                                    </g>
                                </g>
                            </g>

                            <foreignObject>
                                <div className='benefit-item'>

                                    <div className='image-wrapper'>
                                        <img src='/images/relaxed-man-on-the-cloud.png'/>
                                    </div>

                                    <div className='description'>
                                        <div className='header'>
                                            No more struggle <br/>to control who <br/>knows what
                                        </div>
                                        <p>
                                            Businesses see you as different personas,
                                            there is no link between them,
                                            and none of these identities leads to your real one.
                                        </p>
                                    </div>

                                </div>
                            </foreignObject>

                            <foreignObject>
                                <div className='benefit-item'>

                                    <div className='image-wrapper'>
                                        <img src='/images/virtual-card.png'/>
                                    </div>

                                    <div className='description'>
                                        <div className='header'>
                                            Safe payments<br/> on your terms
                                        </div>
                                        <p>
                                            Get a unique card number<br/>for a particular merchant<br/>or each transaction.<br/>
                                            Your shopping habits<br/>cannot be tracked.
                                        </p>
                                    </div>

                                </div>
                            </foreignObject>

                            <foreignObject>
                                <div className='benefit-item'>

                                    <div className='image-wrapper'>
                                        <img src='/images/no-spam-no-robocalling-no-bothering.png'/>
                                    </div>

                                    <div className='description'>
                                        <div className='header'>
                                            No spam, <br/>no robocalling, <br/>no bothering
                                        </div>
                                        <p>
                                            Masked emails and phone numbers allow you to communicate with individual services,
                                            make business deals or sell on online auctions.
                                        </p>
                                    </div>

                                </div>
                            </foreignObject>

                            <foreignObject>
                                <div className='benefit-item'>

                                    <div className='image-wrapper'>
                                        <img src='/images/hook-phishing-attact.png'/>
                                    </div>

                                    <div className='description'>
                                        <div className='header'>
                                            Phishing protection
                                        </div>
                                        <p>
                                            Dedicated identities protect you against attacks
                                            when someone tries to impersonate others
                                            to steal information from you.
                                        </p>
                                    </div>

                                </div>
                            </foreignObject>

                        </svg>

                        <div id='path-mobile'>
                            <div className='benefit-item'>

                                <div className='image-wrapper'>
                                    <img src='/images/relaxed-man-on-the-cloud.png'/>
                                </div>

                                <div className='description'>
                                    <div className='header'>
                                        No more struggle to control who knows what
                                    </div>
                                    <p>
                                        Businesses see you as different personas,
                                        there is no link between them,
                                        and none of these identities leads to your real one.
                                    </p>
                                </div>

                            </div>
                            <div className='benefit-item'>

                                <div className='image-wrapper'>
                                    <img src='/images/virtual-card.png'/>
                                </div>

                                <div className='description'>
                                    <div className='header'>
                                        Safe payments<br/> on your terms
                                    </div>
                                    <p>
                                        Get a unique card number for a particular merchant or each transaction.
                                        Your shopping habits cannot be tracked.
                                    </p>
                                </div>

                            </div>
                            <div className='benefit-item'>

                                <div className='image-wrapper'>
                                    <img src='/images/no-spam-no-robocalling-no-bothering.png'/>
                                </div>

                                <div className='description'>
                                    <div className='header'>
                                        No spam, no robocalling,<br/>no bothering
                                    </div>
                                    <p>
                                        Masked emails and phone numbers allow you to communicate with individual services,
                                        make business deals or sell on online auctions.
                                    </p>
                                </div>

                            </div>
                            <div className='benefit-item'>

                                <div className='image-wrapper'>
                                    <img src='/images/hook-phishing-attact.png'/>
                                </div>

                                <div className='description'>
                                    <div className='header'>
                                        Phishing protection
                                    </div>
                                    <p>
                                        Dedicated identities protect you against attacks
                                        when someone tries to impersonate others
                                        to steal information from you.
                                    </p>
                                </div>

                            </div>
                        </div>

                    </div>

                </div>

            </div>
        )
    }
}